import script from "./employees.vue?vue&type=script&setup=true&lang=ts"
export * from "./employees.vue?vue&type=script&setup=true&lang=ts"

import "./employees.vue?vue&type=style&index=0&id=07b05278&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b05278"]])

export default __exports__